import hamletClient from 'modules/hamlet';
import { HamsCart } from 'modules/cart/duck/model';

const removeItems = (cartId: string, cartItemId: number[]): Promise<HamsCart> =>
  hamletClient
    .post(`/1.0/public/order/cart/${cartId}/removeItems`, undefined, {
      params: { cartItemId },
    })
    .then((response) => response.data);

export default removeItems;
